import { render, staticRenderFns } from "./NewEditUsuarioPage.vue?vue&type=template&id=5ba037fc"
import script from "./NewEditUsuarioPage.vue?vue&type=script&lang=js"
export * from "./NewEditUsuarioPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports